export interface AccumIn {
  readonly accMs: number;
  readonly deltaMs: number;
  readonly tickMs: number;
  readonly maxFrameDeltaMs: number;
  readonly maxCatchupTicks: number;
}

export interface AccumOut {
  readonly ticks: number;
  readonly accMs: number;
  readonly clampedMs: number;
}

/**
 * 고정 틱 누적기. 순수 함수 — 프레임 간격이 16/8/33ms 어느 쪽이든 같은 틱 수를 만든다.
 * 게임 상태 갱신에 delta time 을 쓰지 않는 이유가 이 함수다.
 */
export function ticksToRun(inp: AccumIn): AccumOut {
  const clamped = Math.min(inp.deltaMs, inp.maxFrameDeltaMs);
  const clampedMs = Math.max(0, inp.deltaMs - clamped);
  let acc = inp.accMs + clamped;
  let ticks = 0;
  while (acc >= inp.tickMs && ticks < inp.maxCatchupTicks) {
    acc -= inp.tickMs;
    ticks++;
  }
  if (ticks >= inp.maxCatchupTicks && acc >= inp.tickMs) acc = 0; // 캐치업 상한에서 잔여 폐기
  return { ticks, accMs: acc, clampedMs };
}
